"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var imrc_datetime_picker_1 = require("imrc-datetime-picker");
require("imrc-datetime-picker/dist/imrc-datetime-picker.min.css");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var literals_1 = __importDefault(require("../../literals"));
var LanguageContext_1 = __importDefault(require("../Provider/LanguageContext"));
var styles_1 = __importDefault(require("./styles"));
// tslint:disable-next-line: max-line-length
var DateTime = function (_a) {
    var isHidden = _a.isHidden, className = _a.className, style = _a.style, initialValue = _a.initialValue, onChange = _a.onChange, minDate = _a.minDate, maxDate = _a.maxDate, placeholder = _a.placeholder, form = _a.form, isDisabled = _a.isDisabled, _b = _a.showTime, showTime = _b === void 0 ? true : _b;
    if (isHidden)
        return null;
    var _c = react_1.useState(initialValue ? moment_1.default(initialValue) : undefined), value = _c[0], setValue = _c[1];
    var language = react_1.useContext(LanguageContext_1.default);
    var momentValue = !!value ? value : moment_1.default();
    var min = minDate && moment_1.default(minDate);
    var max = maxDate && moment_1.default(maxDate);
    var weekDays = [
        literals_1.default[language].sun,
        literals_1.default[language].mon,
        literals_1.default[language].tue,
        literals_1.default[language].wed,
        literals_1.default[language].thu,
        literals_1.default[language].fri,
        literals_1.default[language].sat
    ];
    var months = [
        literals_1.default[language].january,
        literals_1.default[language].february,
        literals_1.default[language].march,
        literals_1.default[language].april,
        literals_1.default[language].may,
        literals_1.default[language].june,
        literals_1.default[language].july,
        literals_1.default[language].august,
        literals_1.default[language].september,
        literals_1.default[language].october,
        literals_1.default[language].november,
        literals_1.default[language].december,
    ];
    var formattedValue = function () {
        if (!!value) {
            return showTime ? value.format('DD/MM/YYYY HH:mm:ss') : value.format('DD/MM/YYYY');
        }
        else {
            return '';
        }
    };
    var handleChange = function (nextValue) {
        setValue(nextValue);
        onChange(nextValue.toISOString());
    };
    react_1.useEffect(function () {
        if (form)
            form.addEventListener('reset', setValue.bind(undefined, undefined));
    }, [form]);
    return (react_1.default.createElement(styles_1.default, { className: className || '', style: style },
        react_1.default.createElement(imrc_datetime_picker_1.DatetimePickerTrigger, { moment: momentValue, onChange: handleChange, minDate: min, maxDate: max, weeks: weekDays, months: months, lang: language, showTimePicker: showTime, showSecondsPicker: showTime },
            react_1.default.createElement("input", { className: "input", placeholder: placeholder, value: formattedValue(), disabled: isDisabled, readOnly: true }))));
};
exports.default = DateTime;
//# sourceMappingURL=index.js.map